import { gql, TypedDocumentNode } from '@apollo/client'

import { ATTRIBUTE_FRAGMENT } from './attribute'

import type { AbTestsVariantsSchemaDTO } from 'features/ab-tests/api/types/abTestsVariantsSchemaDTO'

export const VIEWABILITY_TOOLS_FRAGMENT: TypedDocumentNode<
  AbTestsVariantsSchemaDTO['viewabilityTools']
> = gql`
  ${ATTRIBUTE_FRAGMENT}

  fragment abTestsVariantsViewabilityToolsFragment on AbTestsVariantsViewabilityTools {
    lazyLoading {
      gamAdRenderMargin {
        ...abTestsVariantsAttributesFragment
      }
      gamAdRequestMargin {
        ...abTestsVariantsAttributesFragment
      }
      label
      mobileScaling {
        ...abTestsVariantsAttributesFragment
      }
    }
    label
  }
`
